export default __webpack_public_path__ + "static/media/backButton.d023e0f1.svg";